import {TableDefinition} from '../../models';

export const REPRESENTATIVE_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Representative.firstName',
    prop: 'firstName',
    visible: true,
    objectName: 'Representative',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Representative.lastName',
    prop: 'lastName',
    visible: true,
    objectName: 'Representative',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Representative.email',
    prop: 'email',
    visible: true,
    objectName: 'Representative',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Representative.phone',
    prop: 'phoneNumber',
    visible: true,
    objectName: 'Representative',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Representative.role',
    prop: 'role',
    visible: true,
    objectName: 'Representative',
    searchFieldType: 'STRING',
    widthBehavior: 'shrink',
    valueKeyPrefix: 'API.types.Representative.role',
  },
  {
    key: 'API.fields.Representative.roles',
    prop: 'privileges',
    visible: true,
    objectName: 'Representative',
    searchFieldType: 'STRING',
    sortDisabled: true,
    arrayConfig: {
      displayProperty: '',
      maxVisible: 3,
      tagStyle: 'pills',
      moreText: '+{count}',
    } as any,
  },
  {
    key: 'API.fields.Representative.orgPositions',
    prop: 'orgPositions',
    visible: false,
    objectName: 'Representative',
    searchFieldType: 'STRING',
    sortDisabled: true,
    arrayConfig: {
      displayProperty: '',
      maxVisible: 5,
      tagStyle: 'pills',
      moreText: '+{count}',
    } as any,
  },
];
